export default __webpack_public_path__ + "static/media/01.b0cb98f1.jpg";